const EMAIL = {
  SALES: "mailto:sales@read.ai",
  SUPPORT: "mailto:support@read.ai",
};

const MARKETING_SITE = {
  BENCHMARKS: "https://www.read.ai/benchmarks",
  DASHBOARD: "https://www.read.ai/dashboard",
  DATA_PROCESSING_ADDENDUM: "https://www.read.ai/data-processing-addendum",
  HOME: "https://www.read.ai",
  MEETING_TOOLS: "https://www.read.ai/meeting-tools",
  PLANS_PRICING: "https://read.ai/plans-pricing",
  PLAYBACK: "https://www.read.ai/conversationalintelligence",
  PRIVACY: "https://www.read.ai/privacy",
  PRIVACY_POLICY: "https://www.read.ai/privacy-policy",
  RSS: "https://www.read.ai/rss",
  RSS_FAQ: "https://www.read.ai/rss#frequently-asked-questions",
  SLACK: "https://www.read.ai/slack",
  TERMS_OF_SERVICE: "https://www.read.ai/tos",
  TRANSCRIPTION: "https://www.read.ai/transcription",
  UPDATED_PRIVACY_POLICY: "https://www.read.ai/updated-privacy-policy",
  UPDATED_TERMS_OF_SERVICE: "https://www.read.ai/updated-termsofservice",
  WORKSPACES: "https://read.ai/workspaces",
};

const SUPPORT_ARTICLES = {
  ROOT: "https://support.read.ai/hc/en-us",
  NEW_REQUEST: "https://support.read.ai/hc/en-us/requests/new",
  CONFIGURE_DOMAIN_CAPTURE:
    "https://support.read.ai/hc/en-us/articles/31529686025107",
  CONFIGURE_SAML: "https://support.read.ai/hc/en-us/articles/20053798660499",
  CONFIGURE_ZAPIER: "https://support.read.ai/hc/en-us/articles/18847506033171",
  CONNECT_CALENDAR:
    "https://support.read.ai/hc/en-us/articles/10568150023059-What-meetings-does-Read-join-when-I-connect-my-calendar-",
  CONNECT_USER_SLACK:
    "https://support.read.ai/hc/en-us/articles/24264608066579-Integrations-Connecting-your-account-to-Slack",
  CONNECT_WORKSPACE_SLACK:
    "https://support.read.ai/hc/en-us/articles/19805355167251-Integrations-Getting-Started-with-Slack",
  CONNECT_HUBSPOT:
    "https://support.read.ai/hc/en-us/articles/29800922318611-Integrations-Connecting-Your-Read-Account-to-HubSpot",
  CONNECT_GOOGLE_DOCS:
    "https://support.read.ai/hc/en-us/articles/33375140571283",
  CONNECT_ONENOTE: "https://support.read.ai/hc/en-us/articles/33381852777363",
  CONNECT_JIRA: "https://support.read.ai/hc/en-us/articles/34204676394643",
  CONNECT_CONFLUENCE:
    "https://support.read.ai/hc/en-us/articles/34204687160467",
  CONNECT_NOTION: "https://support.read.ai/hc/en-us/articles/35225352186131",
  COULDNT_MANUALLY_ADD_READ:
    "https://support.read.ai/hc/en-us/articles/10539227525267-Why-didn-t-Read-join-my-meeting#h_01HTS39GEXEH2DE0MTTY1DYEWC",
  CREATE_WEBHOOK_INTEGRATION:
    "https://support.read.ai/hc/en-us/articles/16352415827219-Create-a-Custom-Webhook-Integration",
  DUPLICATE_ACCOUNTS:
    "https://support.read.ai/hc/en-us/articles/20904574423187",
  ENFORCE_SAML: "https://support.read.ai/hc/en-us/articles/35630561160979",
  FIND_MEETING_URL:
    "https://support.read.ai/hc/en-us/articles/16949118971667-How-do-I-manually-add-Read-to-a-live-meeting#h_01HV8QMRJPB5PX5FY08GSDCF2B",
  INCOMPLETE_REPORTS:
    "https://support.read.ai/hc/en-us/articles/24017617844627-What-is-the-Incomplete-tab-under-Meeting-Reports-",
  MANUALLY_ADD_READ:
    "https://support.read.ai/hc/en-us/articles/16949118971667-How-do-I-manually-add-Read-to-a-meeting",
  NO_READOUTS:
    "https://support.read.ai/hc/en-us/articles/30561969569555-Why-am-I-not-getting-Readouts-email-and-messaging-reports",
  READ_DIDNT_JOIN:
    "https://support.read.ai/hc/en-us/articles/10539227525267-Why-didn-t-Read-join-my-meeting",
  SUPPORTED_LANGUAGES:
    "https://support.read.ai/hc/en-us/articles/22189506678803-What-languages-does-Read-support",
  ZOOM_ENABLE_LOCAL_RECORDING:
    "https://support.zoom.us/hc/en-us/articles/201362473-Enabling-and-starting-local-recordings#:~:text=Sign%20in%20to%20the%20Zoom%20web%20portal.,to%20enable%20or%20disable%20it.",
};

const THIRD_PARTY = {
  GOOGLE_API_SERVICES_DATA_POLICY:
    "https://developers.google.com/terms/api-services-user-data-policy",
  GOOGLE_CALENDAR: "https://calendar.google.com",
  GOOGLE_MAIL: "https://mail.google.com",
  GOOGLE_MEET: "https://meet.google.com",
  NOTION: "https://notion.so",
  SLACK_APPS: "https://app.slack.com/apps-manage",
  ZOOM_ACCOUNT: "https://zoom.us/meeting",
  READ_ZAPIER_APP: "https://zapier.com/apps/read-ai/integrations",
};

const CHROME_EXTENSION = {
  DOWNLOAD:
    "https://chromewebstore.google.com/detail/read-ai-for-gmail-and-mee/aiamjjeggglngiggkmmbnpnpeejjejaf",
};

const EDGE_EXTENSION = {
  DOWNLOAD: "", // TODO(ENG-14783): Add Edge extension download link after it's published
};

const LINKS = {
  EMAIL,
  MARKETING: MARKETING_SITE,
  SUPPORT: SUPPORT_ARTICLES,
  THIRD_PARTY,
  CHROME_EXTENSION,
  EDGE_EXTENSION,
};

export default LINKS;
